export default __webpack_public_path__ + "static/media/board.1c185333.jpg";